import React from "react";
import {
  MdOutlineKeyboardArrowLeft,
  MdOutlineKeyboardArrowRight,
  MdOutlineKeyboardDoubleArrowLeft,
  MdOutlineKeyboardDoubleArrowRight,
} from "react-icons/md";

const Pagination = ({ currentPage, setCurrentPage, totalPages }) => {
  const generatePageNumbers = () => {
    const pages = [];
    const maxVisible = 5;

    if (totalPages <= maxVisible) {
      // Mostrar todas las páginas si son menores o iguales a maxVisible
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
    } else if (currentPage <= 3) {
      // Mostrar las primeras páginas si estás cerca del inicio
      for (let i = 1; i <= maxVisible - 1; i++) {
        pages.push(i);
      }
      pages.push("...");
      pages.push(totalPages);
    } else if (currentPage >= totalPages - 2) {
      // Mostrar las últimas páginas si estás cerca del final
      pages.push(1);
      pages.push("...");
      for (let i = totalPages - (maxVisible - 2); i <= totalPages; i++) {
        pages.push(i);
      }
    } else {
      // Mostrar páginas alrededor de la página actual
      pages.push(1);
      pages.push("...");
      for (let i = currentPage - 1; i <= currentPage + 1; i++) {
        pages.push(i);
      }
      pages.push("...");
      pages.push(totalPages);
    }

    return pages;
  };

  const onClickNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const onClickPrevPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const onClickSkipToFirst = () => {
    setCurrentPage(1);
  };

  const onClickSkipToLast = () => {
    setCurrentPage(totalPages);
  };

  const pages = generatePageNumbers();

  return (
    <div className="flex flex-row items-center my-6">
      <button
        className={`mx-1 p-2 ${
          currentPage > 1
            ? "bg-light-green text-dark-green hover:bg-simple-gray"
            : "text-simple-gray cursor-not-allowed"
        } rounded-[5px]  transition-colors`}
        onClick={onClickSkipToFirst}
        disabled={currentPage == 1}
      >
        <MdOutlineKeyboardDoubleArrowLeft />
      </button>
      <button
        className={`mx-2 p-2 rounded-[5px] transition-colors flex flex-row items-center ${
          currentPage > 1
            ? "bg-light-green text-dark-green hover:bg-simple-gray"
            : "text-simple-gray cursor-not-allowed"
        }`}
        onClick={onClickPrevPage}
        disabled={currentPage <= 1}
      >
        <MdOutlineKeyboardArrowLeft />
      </button>

      {pages.map((pg, i) =>
        pg === "..." ? (
          <span key={i} className="mx-1 text-gray-500">
            ...
          </span>
        ) : (
          <button
            key={i}
            className={`mx-1 w-[30px] h-[30px] rounded-full transition-colors ${
              currentPage === pg
                ? "bg-simple-red text-white"
                : "bg-white text-dark-green hover:bg-light-green"
            }`}
            onClick={() => {
              setCurrentPage(pg);
            }}
          >
            {pg}
          </button>
        )
      )}

      <button
        className={`mx-2 p-2 rounded-[5px] transition-colors flex flex-row items-center ${
          currentPage < totalPages
            ? "bg-light-green text-dark-green hover:bg-simple-gray"
            : "text-simple-gray cursor-not-allowed"
        }`}
        onClick={onClickNextPage}
        disabled={currentPage == totalPages}
      >
        <MdOutlineKeyboardArrowRight />
      </button>
      <button
        className={`${
          currentPage < totalPages
            ? "bg-light-green text-dark-green hover:bg-simple-gray"
            : "text-simple-gray cursor-not-allowed"
        } mx-1 p-2  rounded-[5px]  transition-colors`}
        onClick={onClickSkipToLast}
        disabled={currentPage == totalPages}
      >
        <MdOutlineKeyboardDoubleArrowRight />
      </button>
    </div>
  );
};

export default Pagination;
